import { ReactElement } from "react";

export interface LiveDevice {
  clientId: string;
  clientName: string;
  companyName: string;
  fileName: string;
  path: string;
}

interface LiveInspectionsBannerProps {
  devices: LiveDevice[];
  onWatchLive: (device: LiveDevice) => void;
}

export function LiveInspectionsBanner({ devices, onWatchLive }: LiveInspectionsBannerProps): ReactElement | null {
  if (devices.length === 0) return null;

  return (
    <div className="row mb-4">
      <div className="col-12">
        <div
          className="card"
          style={{
            border: "1px solid rgba(39, 174, 96, 0.35)",
            borderRadius: "0.75rem",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="d-flex align-items-center justify-content-between px-3 py-2"
            style={{
              backgroundColor: "rgba(39, 174, 96, 0.06)",
              borderBottom: "1px solid rgba(39, 174, 96, 0.2)",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <span
                className="spinner-grow spinner-grow-sm bg-success"
                style={{ width: 7, height: 7 }}
              />
              <span className="fw-semibold text-success" style={{ fontSize: "0.8rem" }}>
                {devices.length} device{devices.length !== 1 ? "s" : ""} live now
              </span>
            </div>
            <span className="text-muted" style={{ fontSize: "0.65rem" }}>
              Auto-refreshing
            </span>
          </div>

          {/* Device Rows */}
          {devices.map((device, index) => (
            <div
              key={device.clientId}
              className="d-flex flex-row align-items-center justify-content-between px-3 py-2 gap-2"
              style={{
                borderBottom:
                  index < devices.length - 1
                    ? "1px solid var(--bs-border-color, #dee2e6)"
                    : undefined,
                cursor: "pointer",
                transition: "background-color 0.1s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "rgba(39, 174, 96, 0.04)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
              onClick={() => onWatchLive(device)}
            >
              <div className="d-flex align-items-center gap-2" style={{ minWidth: 0, overflow: "hidden" }}>
                <span
                  className="spinner-grow spinner-grow-sm bg-success flex-shrink-0"
                  style={{ width: 6, height: 6 }}
                />
                <div style={{ minWidth: 0, overflow: "hidden" }}>
                  <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-sm-2">
                    <span
                      className="fw-semibold text-truncate"
                      style={{ fontSize: "0.8125rem" }}
                    >
                      {device.clientName}
                    </span>
                    <code
                      className="text-muted text-truncate align-self-start"
                      style={{
                        fontSize: "0.6875rem",
                        backgroundColor: "var(--bs-secondary-bg, #e9ecef)",
                        padding: "1px 6px",
                        borderRadius: "4px",
                        maxWidth: "100%",
                      }}
                    >
                      {device.fileName} 
                    </code>
                  </div>
                  <div className="text-muted" style={{ fontSize: "0.6875rem" }}>
                    {device.companyName}                   
                  </div>
                </div>
              </div>

              <button
                className="btn btn-success btn-sm rounded-pill d-flex align-items-center justify-content-center gap-1 flex-shrink-0"
                style={{ fontSize: "0.6875rem", padding: "0.25rem 0.75rem", whiteSpace: "nowrap" }}
                onClick={(e) => {
                  e.stopPropagation();
                  onWatchLive(device);
                }}
              >
                <i className="fa fa-broadcast-tower" style={{ fontSize: "0.6rem" }} />
                Watch now
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}